import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Context } from '../../../store/Store.js';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';
import { useUser } from '../../../contexts/userContext.js';
import NoProgramsEmptyState from '../EmptyState/NoProgramsEmptyState/NoProgramsEmptyState.js';
import NoResultsEmptyState from '../EmptyState/NoResultsEmptyState/NoResultsEmptyState.js';

const ValidationWrapper = ({
  children,
  validatePrograms = false,
  validateResults = false,
  resultsValidationStatus = null,
  additionalValidations = [],
}) => {
  const [state] = useContext(Context);
  const { nameConventions } = useNameConventions();
  const { user, resultTypes } = useUser();
  const programsAreValid = state.programCountForActiveBudget !== 0;

  const validationContext = { state, user, resultTypes, resultsValidationStatus, nameConventions };

  const validations = [
    {
      enabled: validatePrograms,
      isValid: () => programsAreValid,
      fallback: <NoProgramsEmptyState nameConventions={nameConventions} />,
    },
    {
      enabled: validateResults,
      isValid: (validationContext) => validationContext.resultsValidationStatus !== false,
      fallback: <NoResultsEmptyState nameConventions={nameConventions} />,
    },
    ...additionalValidations,
  ];

  const failedValidation = validations.find(({ enabled = true, isValid }) => (
    enabled && !isValid(validationContext)
  ));

  if (failedValidation) return failedValidation.fallback;

  return children;
};

ValidationWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  validatePrograms: PropTypes.bool,
  validateResults: PropTypes.bool,
  resultsValidationStatus: PropTypes.bool,
  additionalValidations: PropTypes.arrayOf(PropTypes.shape({
    enabled: PropTypes.bool,
    isValid: PropTypes.func.isRequired,
    fallback: PropTypes.node.isRequired,
  })),
};

export default ValidationWrapper;
